import React from "react";
import { connect } from "react-redux";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import { TStateMapper } from "tsi-common-react/src/apps/reducers.interfaces";
import {
    ILocation,
    IRetailStoreWithDistance,
} from "tsi-common-react/src/models/location.interfaces";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";

import { LocatorSendSingleStore as LocatorSendSingleStoreComponent } from "../components/LocatorSendSingleStore";
import { defaultLocation } from "../defaults";
import { getStoreByExternalID } from "../loaders";

interface IReduxProps {
    location: ILocation | null;
}

interface IOwnProps {
    storeID: ISyncStoreID;
}

type IProps = IReduxProps & IOwnProps;

interface IState {
    store: IRetailStoreWithDistance | null;
}

// TODO(ssr, MEDIUM 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to async store loading in componentDidMount and componentDidUpdate, state management for store data, and Redux connection.
class LocatorSendSingleStoreContainer extends React.Component<IProps, IState> {
    state: IState = {
        store: null,
    };

    componentDidMount() {
        this.loadStore(this.props.storeID);
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.storeID !== this.props.storeID) {
            this.loadStore(this.props.storeID);
        }
    }

    private async loadStore(storeID: ISyncStoreID) {
        const location = this.props.location || defaultLocation;
        const stores = await getStoreByExternalID(location, storeID);
        this.setState({
            store: stores[0] || null,
        });
    }

    render() {
        if (!this.state.store) {
            return null;
        }
        return <LocatorSendSingleStoreComponent store={this.state.store} />;
    }
}

const mapStateToProps: TStateMapper<"retail", IReduxProps, IOwnProps> = (
    state,
    ownProps,
) => {
    return {
        location: preferredLocationSelector(state),
        ...ownProps,
    };
};

export const LocatorSendSingleStore = connect(mapStateToProps)(
    LocatorSendSingleStoreContainer,
);
